import React from "react";
import parse from "html-react-parser";

export default function BlogCard({ blog }) {
  return (
    <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
      <div className="card bg-secondary h-100">
        <img
          style={{
            width: "100%",
            height: "200px",
            objectFit: "cover",
          }}
          src={`${blog?.attributes?.image?.data?.attributes?.url}`}
          className="card-img-top"
          alt={blog.attributes.title}
        />
        <div className="card-body px-2 d-flex flex-column justify-content-between">
          <div className="card-content">
          <h3
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            className="mt-1 h5"
          >
            {blog?.attributes?.title}
          </h3>
          <span
            className="card-text"
            style={{
              height: "60px",
            }}
            dangerouslySetInnerHTML={{ __html: blog?.attributes?.short_description }}
          >
            {/* {parse(blog?.attributes?.short_description)} */}
          </span>
          </div>
          <a
            href={`${blog?.attributes?.seo?.canonicalURL}`}
            className="btn btn-tertiary my-2" 
            style={{ width: "fit-content"}}
          >
            Read More
          </a>
        </div>
      </div>
    </div>
  );
}
